import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import { Content, Button, Subbutton, LogoutButton } from './user-block.styled';
import { setOnetime, setRegular } from 'store/actions/windows';

const setOnetimeCountersMethod = 'users.set_onetime_counters';
const setRegularCountersMethod = 'users.set_regular_counters';
let newOnetime = false;
let newRegular = false;

export const UserBlock = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  // меню открывается по :hover — после клика по пункту прячем его, пока курсор не покинет кнопку
  const [menuClosed, setMenuClosed] = useState(false);
  const dispatch = useDispatch();
  const onetime = useSelector((store) => store.windows.onetime);
  const regular = useSelector((store) => store.windows.regular);

  useEffect(() => {
    const updateStateRegular = (_msg) => {
      dispatch(setRegular(newRegular));
      setLoading2(false);
    };
    const updateStateOnetime = (_msg) => {
      dispatch(setOnetime(newOnetime));
      setLoading(false);
    };
    socket.on(setOnetimeCountersMethod, updateStateOnetime);
    socket.on(setRegularCountersMethod, updateStateRegular);
    return () => {
      socket.off(setOnetimeCountersMethod, updateStateOnetime);
      socket.off(setRegularCountersMethod, updateStateRegular);
    };
  }, []);

  const toggleOnetime = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    newOnetime = !onetime;
    socket.call(setOnetimeCountersMethod, { enabled: newOnetime });
  };

  const toggleRegular = () => {
    if (loading2) {
      return;
    }
    setLoading2(true);
    newRegular = !regular;
    socket.call(setRegularCountersMethod, { enabled: newRegular });
  };

  let name = '';
  if (window.user.info && window.user.info.config) {
    name = window.user.info.config.name;
  }

  const showSIPPopup = () => {
    props.openWindow({
      id: 'settingssipwindow',
      type: 'settingssip',
      data: {},
      header: t('widgets.Настройка SIP номера'),
    });
  };

  const showLimitsPopup = () => {
    props.openWindow({
      id: 'settingslimitswindow',
      type: 'settingslimits',
      data: {},
      header: t('widgets.Количество мест для постоянных клиентов'),
    });
  };

  const showReceiptPopup = () => {
    props.openWindow({
      id: 'settingsreceiptwindow',
      type: 'settingsreceipt',
      data: {},
      header: t('widgets.Шаблон билета'),
    });
  };

  const withRegular = user.haveRight('zones.set_regular_places');
  const withReceipt = user.haveRight('receipt_template.edit');
  const cl = 'sb-all sb-input ' + (loading ? ' loading' : '');
  const cl2 = 'sb-all sb-input ' + (loading2 ? ' loading' : '');

  return (
    <Content>
      <Button className={menuClosed ? 'menu-closed' : ''} onMouseLeave={() => setMenuClosed(false)}>
        {t('widgets.Настройки')}
        <span className="menu1">
          <span className="menu1items">
            {/*
            <Subbutton className="sb-top" onClick={showPopup}>
              Вид парковочного билета
            </Subbutton>*/}
            <Subbutton className="sb-all" onClick={() => {
                setMenuClosed(true);
                showSIPPopup();
              }}>
              {t('widgets.SIP номер')}
            </Subbutton>
            {withRegular && (
              <Subbutton className="sb-all" onClick={() => {
                setMenuClosed(true);
                showLimitsPopup();
              }}>
                {t('widgets.Постоянные клиенты')}
              </Subbutton>
            )}
            {withReceipt && (
              <Subbutton className="sb-all" onClick={() => {
                setMenuClosed(true);
                showReceiptPopup();
              }}>
                {t('widgets.Шаблон билета')}
              </Subbutton>
            )}
            <Subbutton className={cl} onClick={toggleOnetime}>
              <input type="checkbox" checked={onetime} onChange={() => null} /> {t('widgets.Разовые клиенты')}
            </Subbutton>
            <Subbutton className={cl2} onClick={toggleRegular}>
              <input type="checkbox" checked={regular} onChange={() => null} /> {t('widgets.Постоянные клиенты')}
            </Subbutton>
          </span>
        </span>
      </Button>
      <div>{name}</div>
      <LogoutButton onClick={window.user.logoutUser}>
        <img src="/images/new-logout.svg" alt="" width={'15px'} />
        <span>{t('windows.Выход')}</span>
      </LogoutButton>
    </Content>
  );
};
